import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IParavetClinicListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useParavetClinicListAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [clinicList, setClinicList] = useState([]);

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response = await axios.get<IParavetClinicListResponse>(CONFIGURATION_APIS.PARAVET_CLINIC_LIST.baseURL, {
        headers: {
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      setClinicList((response.data?.data ?? []) as any);
    } catch (error) {
      setClinicList([]);
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        captureError(axiosError);
        if (axiosError.config) {
          sendCurl(axiosError.config["curlCommand"]);
        }
      }
    }
  }, [configuration]);

  return { execute, clinicList };
};
